import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=2f6827a6&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=2f6827a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6827a6",
  null
  
)

export default component.exports